export default __webpack_public_path__ + "static/media/sale7.bf28750a.webp";